module.exports = __webpack_public_path__ + "img/logo05.0de2753.jpg";